import React from "react";
import axios from "axios";
import $ from "jquery";
import { ToastContainer } from "react-toastify";
import qs from "qs";

import "datatables.net";
import "bootstrap/js/dist/dropdown";

import { configureDataTable } from "../../utils/actions";
import { BACKEND_CONFIG } from "../../config/consts";

import { createClientsTableDataSource } from "./ClientBuilder";
import { onTableInitComplete, reloadClientTable } from "./ClientTableHandlers";

import "../../styles/_datatables.scss";

export class ClientsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      search: this.props.search,
      clientType: this.props.clientType,
      showArchivedClients: false,
      showUnarchivedClients: true,
      //clientId: null,
      statisticsItems: this.props.statisticItems,
      getUpdatedStatisticsCallback: this.props.getUpdatedStatisticsCallback,
    };

    configureDataTable();
  }

  componentDidMount() {
    this.initDataTable();
  }

  initDataTable() {
    var loadClients = (requestData, reloadClientTableCallback) =>
      this.loadClients(requestData, reloadClientTableCallback);
    var performAdditionalFilterInitialization = (filterData) =>
      this.performAdditionalFilterInitialization(filterData);

    $("#tblClients").dataTable({
      processing: true,
      serverSide: true,
      paging: true,
      autoWidth: false,
      destroy: null,
      lengthChange: true,
      pageLength: 10,
      columnDefs: this.props.columns,
      order: this.props.order,
      initComplete: onTableInitComplete,
      language: {
        sProcessing: "",
        emptyTable:
          "<div id='dvNoData' class='center alert alert-info lead'>No clients match search and filter criteria.</div>",
        zeroRecords:
          "<div id='dvNoSearch' class='center alert alert-info lead'>No clients matching that search.</div>",
        loadingRecords: "<b>Please wait - loading...</b>",
        lengthMenu:
          "Show <select id='dlRows' class='center' style = 'width: 60px;'>" +
          "<option value='5'>5</option>" +
          "<option value='10'>10</option>" +
          "<option value='25'>25</option>" +
          "<option value='50'>50</option>" +
          "<option value='-1'>All</option>" +
          "</select> clients per page.",
      },
      ajax: function (filterData, reloadClientTableCallback) {
        performAdditionalFilterInitialization(filterData);
        loadClients(filterData, reloadClientTableCallback);
      },
    });
  }

  performAdditionalFilterInitialization(filterData) {
    filterData.clientType = this.state.clientType;
    filterData.submitted = !this.props.unsubmittedClients;
    filterData.businessName = this.state.search;
    filterData.search = { value: this.state.search, regex: false };
    filterData.archived = this.state.showArchivedClients;
    filterData.unarchived = this.state.showUnarchivedClients;
    //data.clientId = this.state.clientId;
  }

  loadClients(requestData, reloadClientTableCallback) {
    axios
      .get(`${BACKEND_CONFIG.apiUrl}agency/clients`, {
        params: requestData,
        paramsSerializer: {
          serialize: function (params) {
            return qs.stringify(params);
          },
        },
      })
      .then((data) => {
        var responseData = data.data;
        var isFirstPage = requestData.start === 0;
        var noClientsOnCurrentPage = responseData.data.length === 0;

        if (noClientsOnCurrentPage && !isFirstPage) {
          this.loadPreviousPage(requestData, reloadClientTableCallback);
          return;
        }

        this.processClientData(responseData, reloadClientTableCallback);
      })
      .catch(() => {});
  }

  loadPreviousPage(requestData, reloadClientTableCallback) {
    requestData.start = requestData.start - requestData.length;
    requestData.draw = requestData.draw - 1;
    this.loadClients(requestData, reloadClientTableCallback);
  }

  processClientData(responseData, reloadClientTableCallback) {
    var users = [];

    if (responseData.Users) {
      users = responseData.Users.Users;
    }

    reloadClientTableCallback({
      data: createClientsTableDataSource(
        responseData.data,
        users,
        responseData.UaUrl,
        this.props.settings
      ),
      recordsTotal: responseData.recordsTotal,
      draw: responseData.draw,
      recordsFiltered: responseData.recordsFiltered,
    });
    this.setState({
      statisticsItems: this.state.getUpdatedStatisticsCallback(responseData),
    });
  }

  onKeyPress(e) {
    if (e.charCode === 13) {
      this.setState({ search: e.target.value }, () => reloadClientTable(true));
    }
  }

  render() {
    return (
      <div>
        <ToastContainer theme="colored" />
        <div>
          <h1 className="page-header">{this.props.pageHeader}</h1>
          <div className="row align-items-center w-100 ml-0 mr-0 search-n-statisic">
            <div className="col-auto pr-0 pl-0 ml-0 mr-0 div-table-search">
              <input
                className="input-table-search"
                type="text"
                defaultValue={this.props.search}
                placeholder="Search a Name, Client ID, Phone #, or Policy #"
                onBlur={(e) => {
                  this.setState({ search: e.target.value });
                }}
                onKeyPress={(e) => this.onKeyPress(e)}
              />
              <div
                className="search-btn float-right"
                onClick={() => reloadClientTable(true)}
              >
                <img
                  src="/content/images/looking-glass.svg"
                  style={{ marginLeft: "8px", marginTop: "8px" }}
                  alt=""
                />
              </div>
            </div>
          </div>
          <div
            id="dvFilter"
            className="row align-items-center justify-content-between w-100 ml-0 mr-0"
          >
            <div>
              <span className="col-auto row align-content-center pr-0 pl-0 ml-0 mr-0">
                <input
                  type="checkbox"
                  checked={this.state.showArchivedClients}
                  onChange={(e) =>
                    this.setState(
                      { showArchivedClients: e.target.checked },
                      () => reloadClientTable(false)
                    )
                  }
                />
                Show Archived Clients
                <input
                  type="checkbox"
                  checked={this.state.showUnarchivedClients}
                  onChange={(e) =>
                    this.setState(
                      { showUnarchivedClients: e.target.checked },
                      () => reloadClientTable(false)
                    )
                  }
                />
                Show Unarchived Clients
              </span>
            </div>
            <div className="client-filter col-auto row align-content-center justify-content-between ml-0 mr-0 pr-0">
              <span className="float-left">Filter:</span>
              <select
                className="small-select"
                defaultValue={this.state.clientType}
                onChange={(e) =>
                  this.setState({ clientType: e.target.value }, () =>
                    reloadClientTable(true)
                  )
                }
              >
                {this.props.clientTypes.map((clientType) => {
                  return (
                    <option key={clientType.value} value={clientType.value}>
                      {clientType.name}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        </div>
        <div id="dvClients">
          <table id="tblClients" className="dataTable" />
        </div>
      </div>
    );
  }
}
